var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSymbolQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 117,
    viewBox: "0 0 66 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 0C15.046 0 0 15.2164 0 34.6525H6.70115C6.70115 18.541 18.3333 6.90492 33 6.90492C47.6667 6.90492 59.2988 18.541 59.2988 33.3738C59.2988 41.1738 56.1379 48.2066 50.3218 53.4492C45.6437 57.6688 39.4483 59.9705 33 59.9705H29.5862V97.8197H36.4138V66.6197C42.3563 66.2361 49.4368 63.2951 54.8736 58.3082C61.8276 52.1705 66 42.8361 66 33.3738C66 15.2164 50.954 0 33 0ZM33 106.131C30.2184 106.131 27.6897 108.816 27.6897 111.63C27.6897 114.315 30.2184 117 33 117C35.7816 117 38.3103 114.315 38.3103 111.63C38.3103 108.816 35.7816 106.131 33 106.131Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolQuestion);
export default __webpack_public_path__ + "static/media/SYMBOL_QUESTION.4f6f5700efe1cebc23f84353d3f3c742.svg";
export { ForwardRef as ReactComponent };